import React from "react";
import { MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";

const MenuCategory = styled(MenuItem)({
    fontSize: "13px",
    fontWeight: 600,
    background: "rgb(240,240,240)",
    color: "rgba(0, 0, 0, 0.87)",
    "& > a:hover": {
        cursor: "default",
    },
});

const MenuSubItem = styled(MenuItem)({
    fontSize: "14px",
    padding: "16px"
});

const LeaseAndSaleDropdownOptions = (props) => {
    const { callback, addConsultingBlock, addNoListingText, property } = props;
    const handleNewTransaction = (spaceUse, transactionType) => {
        if (property) {
            callback(property, spaceUse, transactionType);
        } else {
            callback(spaceUse, transactionType);
        }
    };

    return (
        <React.Fragment>
            {addConsultingBlock && (
                <React.Fragment>
                    <MenuCategory disabled disableAutoFocusItem>
                        Consulting (No Listing)
                    </MenuCategory>
                    <MenuSubItem onClick={() => handleNewTransaction(null, "Consulting")}>Consulting Deal</MenuSubItem>
                </React.Fragment>
            )}
            <MenuCategory disabled disableAutoFocusItem>
                {addNoListingText ? "Lease (No Listing)" : "Lease"}
            </MenuCategory>
            <MenuSubItem onClick={() => handleNewTransaction("Office", "Lease")}>Office Lease</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Industrial", "Lease")}>Industrial Lease</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Retail", "Lease")}>Retail Lease</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Land", "Lease")}>Land Lease</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Multifamily", "Lease")}>Multifamily Lease</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Life Science", "Lease")}>Life Science Lease</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Healthcare", "Lease")}>Healthcare Lease</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Religious", "Lease")}>Religious Lease</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Educational", "Lease")}>Educational Lease</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Other", "Lease")}>Other Lease</MenuSubItem>
            <MenuCategory disabled disableAutoFocusItem>
                {addNoListingText ? "Sale (No Listing)" : "Sale"}
            </MenuCategory>
            <MenuSubItem onClick={() => handleNewTransaction("Office", "Sale")}>Office Sale</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Industrial", "Sale")}>Industrial Sale</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Retail", "Sale")}>Retail Sale</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Land", "Sale")}>Land Sale</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Hospitality", "Sale")}>Hospitality Sale</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Multifamily", "Sale")}>Multifamily Sale</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Life Science", "Sale")}>Life Science Sale</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Healthcare", "Sale")}>Healthcare Sale</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Religious", "Sale")}>Religious Sale</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Educational", "Sale")}>Educational Sale</MenuSubItem>
            <MenuSubItem onClick={() => handleNewTransaction("Other", "Sale")}>Other Sale</MenuSubItem>
        </React.Fragment>
    );
};

export default LeaseAndSaleDropdownOptions;
